module.exports = __webpack_public_path__ + "img/hk.bcd1bda5.svg";